/* @flow */

import MENSAGENS from '../../mensagens';

import { type Loading } from '../../utils/types';

const loadingInicial: Loading = {
    hide() {
        global.mApp.unblockPage();
    },
    show() {
        global.mApp.blockPage({
            overlayColor: '#000000',
            type: 'loader',
            state: 'success',
            message: MENSAGENS.RELATORIOS.LOADING,
        });
    },
};

export default loadingInicial;
